import Vue from "vue";

// initial state
const state = {
  clientManagement: {},
  locationManagement: {},
  userManagement: {},
  projectManagement: {},
  agencyManagement: {},
  surveyManagement: {},
  checkManagement: {},
  kpiManagement: {},
  shopperManagement: {},
  recruiting_checkFilter: {},
  recruiting_shopperFilter: {},
  shopperApproval: {},
};

const getters = {
  clientManagement: (state) => {
    return state.clientManagement;
  },
  locationManagement: (state) => {
    return state.locationManagement;
  },
  userManagement: (state) => {
    return state.userManagement;
  },
  projectManagement: (state) => {
    return state.projectManagement;
  },
  agencyManagement: (state) => {
    return state.agencyManagement;
  },
  surveyManagement: (state) => {
    return state.surveyManagement;
  },
  checkManagement: (state) => {
    return state.checkManagement;
  },
  kpiManagement: (state) => {
    return state.kpiManagement;
  },
  shopperManagement: (state) => {
    return state.shopperManagement;
  },
  recruiting_checkFilter: (state) => {
    return state.recruiting_checkFilter;
  },
  recruiting_shopperFilter: (state) => {
    return state.recruiting_shopperFilter;
  },
  shopperApproval: (state) => {
    return state.shopperApproval;
  },
};

const actions = {};

const mutations = {
  clearAll(state) {
    state.clientManagement = {};
    state.locationManagement = {};
    state.userManagement = {};
    state.projectManagement = {};
    state.agencyManagement = {};
    state.surveyManagement = {};
    state.checkManagement = {};
    state.kpiManagement = {};
    state.shopperManagement = {};
    state.recruiting_checkFilter = {};
    state.recruiting_shopperFilter = {};
    state.shopperApproval = {};
  },
  clientManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "clientManagement", filters);
  },
  locationManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "locationManagement", filters);
  },
  userManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "userManagement", filters);
  },
  projectManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "projectManagement", filters);
  },
  agencyManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "agencyManagement", filters);
  },
  surveyManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "surveyManagement", filters);
  },
  checkManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "checkManagement", filters);
  },
  kpiManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "kpiManagement", filters);
  },
  shopperManagement(state, filters) {
    filters = filters || {};
    Vue.set(state, "shopperManagement", filters);
  },
  recruiting_checkFilter(state, filters) {
    filters = filters || {};
    Vue.set(state, "recruiting_checkFilter", filters);
  },
  recruiting_shopperFilter(state, filters) {
    filters = filters || {};
    Vue.set(state, "recruiting_shopperFilter", filters);
  },
  shopperApproval(state, filters) {
    filters = filters || {};
    Vue.set(state, "shopperApproval", filters);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/localFilters.js